import { useTranslation } from 'react-i18next'
import { useGreetingStyles } from '@/hooks/api/useGreetings'
import { cn } from '@/lib/utils'

interface ToneChipsProps {
  value?: string
  onChange: (value: string) => void
  className?: string
}

export function ToneChips({ value, onChange, className }: ToneChipsProps) {
  const { t } = useTranslation()
  const { data: styles = [] } = useGreetingStyles()

  // Format style ID to display label
  const formatStyleLabel = (styleId: string): string => {
    // Try to get translation first
    const translationKey = `resources.assistants.greeting_styles.${styleId}`
    const translation = t(translationKey, { defaultValue: '' })

    if (translation && translation !== translationKey) {
      return translation
    }

    // Fallback to formatting the style ID
    return styleId
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  if (styles.length === 0) {
    return null
  }

  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {styles.map((styleId) => {
        const isSelected = value === styleId

        return (
          <button
            key={styleId}
            type="button"
            onClick={() => onChange(styleId)}
            className={cn(
              'rounded-full px-4 py-2 text-sm font-medium transition-all',
              isSelected
                ? 'bg-charcoal text-white dark:bg-gray-100 dark:text-charcoal'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600'
            )}
          >
            {formatStyleLabel(styleId)}
          </button>
        )
      })}
    </div>
  )
}

export default ToneChips
